/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Lot_Picker_SearchInputs */

const vi_lot_items_lot_picker_search = /** @type {(inputs: Lot_Items_Lot_Picker_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gõ mã lô...`)
};

/**

* @param {Lot_Items_Lot_Picker_SearchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_lot_picker_search = /** @type {((inputs?: Lot_Items_Lot_Picker_SearchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Lot_Picker_SearchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_lot_picker_search(inputs)
});